import { render, staticRenderFns } from "./HodoAppDetail.vue?vue&type=template&id=0feb57da&scoped=true"
import script from "./HodoAppDetail.vue?vue&type=script&lang=js"
export * from "./HodoAppDetail.vue?vue&type=script&lang=js"
import style0 from "./HodoAppDetail.vue?vue&type=style&index=0&id=0feb57da&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feb57da",
  null
  
)

export default component.exports